import React from "react";
import InternalHeader from "~/components/Layout/components/InternalHeader";
import { useLang } from "~/hooks/useLang";
import ListAllAuditUserActions from "./components/ListAllAuditUserActions";

export default function AuditUserActionTable() {
    const { translate } = useLang();
    
    

    return (
        <>
            <InternalHeader title={`${translate('Audit')}: ${translate('Actions in occurrence')}`} />
            <ListAllAuditUserActions />
        </>
    )
}